class FetchSubjectTypeDefinitions {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchSubjectTypeDefinitions;
